import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Router, RouterModule } from '@angular/router';
import { Department } from '@models/departments.model';
import { CostumerData } from '@models/user.model';
import { ClubService } from '@services/club.service';
import { MENU_LIST, MENU_MOBILE_LIST } from '@shared/utils';
import { AddCardComponent } from 'src/app/club/add-card/add-card.component';
import { RedeemComponent } from 'src/app/purchase/redeem/redeem.component';
import { SigninComponent } from '../signin/signin.component';
import { MatIconModule } from '@angular/material/icon';
import { NgClass, NgFor, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault, SlicePipe, TitleCasePipe, UpperCasePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-mobile-menu-modal',
  templateUrl: './mobile-menu-modal.component.html',
  styleUrls: ['./mobile-menu-modal.component.scss'],
  standalone: true,
  imports: [MatIconModule, RouterModule, MatDialogModule, NgClass, NgSwitch, SlicePipe, UpperCasePipe, TranslateModule, MatDividerModule, MatFormFieldModule, TitleCasePipe, NgFor, NgIf, NgSwitchCase, NgSwitchDefault],
})
export class MobileMenuModalComponent implements OnInit {
  public menu = MENU_MOBILE_LIST;
  public accountMenu = MENU_LIST;
  public selectedTabIndex: number | null = null;

  public departments: Department[] = [];

  public card_owner: string;
  public clubAmmount: number;
  public clubCardAmount: string;
  public sharedCard: boolean;
  public onlyDepartments: boolean;
  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<MobileMenuModalComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: { departments: Department[], user: CostumerData | null, onlyDepartments?: boolean },
    private clubService: ClubService
  ) {
    this.departments = this.data.departments;
    this.onlyDepartments = this.data.onlyDepartments ?? false;
  }

  ngOnInit(): void {
    if (!this.onlyDepartments) {
      this.getAlsuperPoints();
    } else {
      this.selectedTabIndex = 1;
    }
  }

  private async getAlsuperPoints(): Promise<void> {
    if (this.data.user && this.data.user.membership) {
      try {
        const { data } = await this.clubService.getClubPointsByNumber(this.data.user.membership);
        const [membershipData] = data.membership_data;
        if (membershipData) {
          this.card_owner = membershipData.Mensaje;
          this.clubAmmount = membershipData.Saldo;
          this.clubCardAmount = data.message;
          this.sharedCard = data.shared;
        }
      } catch (error) { }
    }
  }

  public selectTab(index: number): void {
    if (!this.onlyDepartments) {
      if (index === 0 && !this.data.user) {
        this.dialogRef.close();
        this.dialog.open(SigninComponent, { autoFocus: false });
      } else {
        this.selectedTabIndex = this.selectedTabIndex === index ? null : index;
      }
    } else {
      this.dialogRef.close();
    }
  }

  public redirect(route: string): void {
    this.dialogRef.close();
    if (route.includes('listas') && !this.data.user) {
      this.dialog.open(SigninComponent, { autoFocus: false });
    } else {
      this.router.navigate([route]);
    }
  }

  public openClubAlsuper(type: string): void {
    this.dialogRef.close();
    if (this.data.user) {
      switch (type) {
        case 'card':
          this.dialog.open(AddCardComponent, {
            panelClass: 'as-activate-club'
          });
          break;
        case 'redeem':
          this.dialog.open(RedeemComponent, {
            maxWidth: '80vw',
            autoFocus: false,
            data: { hideButton: true }
          });
          break;
      }
    } else {
      this.dialog.open(SigninComponent, { autoFocus: false });
    }
  }

  public closeSesion(): void {
    this.dialogRef.close('signout');
  }
}
